(function (window) {
  function buildAddonItems(selectedAddons, parentId, parentKey = "parent_id", quantity = 1) {
    const items = [];
    const seen = new Set();
    for (const addon of selectedAddons || []) {
      if (!addon.checked) continue;

      const variantId = Number(addon.dataset.variantId);
      if (Number.isFinite(variantId) && variantId > 0 && !seen.has(variantId)) {
        seen.add(variantId);
        const item = { id: variantId, quantity, [parentKey]: parentId };
        const row = addon.closest?.('.m-product-order-addons__item');
        const color = row?.querySelector('[data-addon-color]')?.value.trim();
        const personalization = row?.querySelector('[data-addon-personalization]')?.value.trim();
        if (color || personalization) {
          item.properties = {};
          if (color) item.properties.Culoare = color;
          if (personalization) item.properties[row?.querySelector('[data-addon-personalization]')?.dataset?.addonProperty || 'Personalizare'] = personalization;
        }
        const nameInput = addon.dataset.nameVariant ? row?.querySelector('[data-addon-name]') : null;
        const name = nameInput?.value.trim();
        if (name) {
          item.properties = { ...item.properties, Nume: name };
        }
        items.push(item);
        if (name) {
          items.push({ id: Number(addon.dataset.nameVariant), quantity, [parentKey]: parentId, properties: { Nume: name, Pentru: 'Botoșei asortați' } });
        }
      }
    }

    return items;
  }

  function hasFileProperties(formData) {
    if (typeof File === "undefined") return false;

    for (const [name, value] of formData.entries()) {
      if (name.startsWith("properties[") && value instanceof File && value.size > 0) return true;
    }

    return false;
  }

  function buildCartItems(formData, selectedAddons) {
    const mainItem = {
      id: Number(formData.get("id")),
      quantity: Math.max(1, Number(formData.get("quantity") || 1)),
    };
    const properties = {};

    for (const [name, value] of formData.entries()) {
      const propertyMatch = name.match(/^properties\[(.+)\]$/);
      if (propertyMatch && value !== "") properties[propertyMatch[1]] = value;
    }

    if (Object.keys(properties).length) mainItem.properties = properties;

    const sellingPlan = formData.get("selling_plan");
    if (sellingPlan) mainItem.selling_plan = Number(sellingPlan);

    return [mainItem, ...buildAddonItems(selectedAddons, mainItem.id, "parent_id", mainItem.quantity)];
  }

  class OrderAddonFields {
    constructor() {
      document.addEventListener('change', (event) => {
        if (event.target.matches('[data-product-order-addon]')) this.sync();
      });
      document.addEventListener('input', (event) => {
        if (!event.target.matches('[data-addon-personalization]')) return;
        const row = event.target.closest('.m-product-order-addons__item');
        if (event.target.value.trim()) this.setError(row, false);
      });
      document.addEventListener('input', (event) => {
        if (!event.target.matches('[data-addon-name]')) return;
        const checkbox = event.target.closest('.m-product-order-addons__item').querySelector('[data-product-order-addon]');
        checkbox.dataset.nameVariant = event.target.dataset.nameVariant;
        checkbox.dataset.namePrice = event.target.value.trim() ? event.target.dataset.namePrice : '0';
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      });
      document.addEventListener('input', (event) => {
        if (event.target.matches('[data-trusouri-required]')) this.setTrusouriError(event.target);
      });
      this.sync();
    }
    sync() {
      document.querySelectorAll('[data-addon-fields]').forEach((fields) => {
        const row = fields.closest('.m-product-order-addons__item');
        const checked = row.querySelector('[data-product-order-addon]').checked;
        const checkbox = row.querySelector('[data-product-order-addon]');
        const name = fields.querySelector('[data-addon-name]');
        if (name) {
          checkbox.dataset.nameVariant = name.dataset.nameVariant;
          checkbox.dataset.namePrice = name.value.trim() ? name.dataset.namePrice : '0';
        }
        fields.hidden = !checked;
        fields.querySelectorAll('input').forEach((input) => { input.disabled = !checked; });
        if (!checked) this.setError(row, false);
      });
    }
    setError(row, invalid) {
      row.querySelector('[data-addon-personalization]')?.setAttribute('aria-invalid', String(invalid));
      const error = row.querySelector('[data-addon-error]');
      if (error) error.hidden = !invalid;
    }
    setTrusouriError(input) {
      const invalid = !input.value.trim() || !input.validity.valid;
      input.setAttribute('aria-invalid', String(invalid));
      input.closest('.pc-trusouri__field').querySelector('.pc-trusouri__error').hidden = !invalid;
      return invalid;
    }
    validate(root) {
      let first;
      root?.querySelectorAll('.m-product-order-addons__item').forEach((row) => {
        const input = row.querySelector('[data-addon-personalization]');
        if (!input) return;
        const invalid = row.querySelector('[data-product-order-addon]').checked && !input.value.trim();
        this.setError(row, invalid);
        if (invalid && !first) first = input;
      });
      root?.querySelectorAll('[data-trusouri-required]').forEach((input) => {
        if (this.setTrusouriError(input) && !first) first = input;
      });
      if (first) {
        first.scrollIntoView({ block: 'center', behavior: 'smooth' });
        first.focus({ preventScroll: true });
      }
      return !first;
    }
  }
  if (typeof document !== 'undefined' && !window.MinimogOrderAddonFields) {
    window.MinimogOrderAddonFields = new OrderAddonFields();
  }
  window.MinimogProductOrderAddons = { buildAddonItems, buildCartItems, hasFileProperties };
})(window);
